module.exports = __webpack_public_path__ + "img/013-snail.751df280.svg";